import React, { useEffect, useMemo, useState } from 'react';
import { useIntl, useDispatch, getLocale, useSelector, useLocation, history } from 'umi';
import UserGuideBox from '@/pages/home/components/UserGuideBox';
import { IS_GLOBAL, LANGUAGE_EN } from '@/pages/home/_config/config';
import { GUIDE_SYS_DASHBOARD } from '@/pages/home/models/guide';
import { storage } from '@/utils/utils';

export const DASHBOARD_GUIDE_HIDE = '__db_dashboard_guide_hide__'
export const DASHBOARD_GUIDE_BOX_LIST1 = '__db_dashboard_guide_list1__';
export const DASHBOARD_GUIDE_BOX_LIST2 = '__db_dashboard_guide_list2__';
export const DASHBOARD_GUIDE_BOX_LIST3 = '__db_dashboard_guide_list3__';
export const DASHBOARD_GUIDE_BOX_LIST4 = '__db_dashboard_guide_list4__';
export const DASHBOARD_GUIDE_BOX_LIST5 = '__db_dashboard_guide_list5__';

export const DASHBOARD_GUIDE_BOX_LIST1_PATH = '/dashboard/game/demo/overview/daily';
export const DASHBOARD_GUIDE_BOX_LIST2_PATH = '/dashboard/game/demo/realtime/users';
export const DASHBOARD_GUIDE_BOX_LIST3_PATH = '/dashboard/game/demo/comparisonAnalysis/countryComparison';
export const DASHBOARD_GUIDE_BOX_LIST4_PATH = '/dashboard/game/demo/preset/report/Active-User-Profile';
export const DASHBOARD_GUIDE_BOX_LIST5_PATH = '/dashboard/game/demo/subscribe/subscribeSetting';

export const DASHBOARD_SHOW_GUIDE_GAME_LIST = ['demo'];

export default () => {
  // 新手引导相关
  const locale = getLocale();
  const { formatMessage } = useIntl();
  const location = useLocation();
  const { pathname } = location;
  const guideUsersHide = storage.getLocalStorageItem(DASHBOARD_GUIDE_HIDE);
  const { guideSys, userInfo } = useSelector((state: any) => {
    const { guide: { guideSys }, home: { userInfo } } = state;
    return {
      guideSys,
      userInfo
    }
  });

  const dispatch = useDispatch();

  const setShowGuide = (show: boolean): void => {
    dispatch({
      type: 'guide/showDashboardGuideModule',
      payload: show,
    });
  }

  // 模拟guide数据
  const GuideData = useMemo(() => {
    const { getLocalStorageItem } = storage;
    const { openid = '' } = userInfo || {};
    const list1 = storage.getLocalStorageItem(DASHBOARD_GUIDE_BOX_LIST1);
    const list2 = storage.getLocalStorageItem(DASHBOARD_GUIDE_BOX_LIST2);
    const list3 = storage.getLocalStorageItem(DASHBOARD_GUIDE_BOX_LIST3);
    const list4 = storage.getLocalStorageItem(DASHBOARD_GUIDE_BOX_LIST4);
    const list5 = storage.getLocalStorageItem(DASHBOARD_GUIDE_BOX_LIST5);
    const blockList = [
      {
        tit: formatMessage({id: 'dbh_dashboard_giudebox_list1_title'}),
        des: formatMessage({id: 'dbh_dashboard_giudebox_list1_desc'}),
        checked: (list1 || []).includes(openid),
        onClick: () => {
          dispatch({
            type: 'guide/showDashboardGuideOverview',
          });
          if (pathname !== DASHBOARD_GUIDE_BOX_LIST1_PATH) {
            history.push(DASHBOARD_GUIDE_BOX_LIST1_PATH);
          }
        }
      },
      {
        tit: formatMessage({id: 'dbh_dashboard_giudebox_list2_title'}),
        des: formatMessage({id: 'dbh_dashboard_giudebox_list2_desc'}),
        checked: (list2 || []).includes(openid),
        onClick: () => {
          dispatch({
            type: 'guide/showDashboardGuideRealtime',
          });
          if (pathname !== DASHBOARD_GUIDE_BOX_LIST2_PATH) {
            history.push(DASHBOARD_GUIDE_BOX_LIST2_PATH);
          }
        }
      },
      {
        tit: formatMessage({id: 'dbh_dashboard_giudebox_list3_title'}),
        des: formatMessage({id: 'dbh_dashboard_giudebox_list3_desc'}),
        checked: (list3 || []).includes(openid),
        onClick: () => {
          dispatch({
            type: 'guide/showDashboardGuideCountry',
          });
          if (pathname !== DASHBOARD_GUIDE_BOX_LIST3_PATH) {
            history.push(DASHBOARD_GUIDE_BOX_LIST3_PATH);
          }
        }
      },
      {
        tit: formatMessage({id: 'dbh_dashboard_giudebox_list4_title'}),
        des: formatMessage({id: 'dbh_dashboard_giudebox_list4_desc'}),
        checked: (list4 || []).includes(openid),
        onClick: () => {
          dispatch({
            type: 'guide/showDashboardGuideTableau',
          });
          if (pathname !== DASHBOARD_GUIDE_BOX_LIST4_PATH) {
            history.push(DASHBOARD_GUIDE_BOX_LIST4_PATH);
          }
        }
      },
      // {
      //   tit: formatMessage({id: 'dbh_dashboard_giudebox_list5_title'}),
      //   des: formatMessage({id: 'dbh_dashboard_giudebox_list5_desc'}),
      //   checked: (list5 || []).includes(openid),
      //   onClick: () => {
      //     dispatch({
      //       type: 'guide/showDashboardGuideSubscribe',
      //     });
      //     if (pathname !== DASHBOARD_GUIDE_BOX_LIST5_PATH) {
      //       history.push(`${DASHBOARD_GUIDE_BOX_LIST5_PATH}?queryStr=gameCode=demo&backUrl=/dashboard/game/demo/overview/daily&pageName=总览-运营总况日报&path=/overview/daily&pageType=path`);
      //     }
      //   }
      // },
    ];
    if (!IS_GLOBAL) {
      blockList.push({
        tit: formatMessage({id: 'dbh_dashboard_giudebox_list5_title'}),
        des: formatMessage({id: 'dbh_dashboard_giudebox_list5_desc'}),
        checked: (list5 || []).includes(openid),
        onClick: () => {
          dispatch({
            type: 'guide/showDashboardGuideSubscribe',
          });
          if (pathname !== DASHBOARD_GUIDE_BOX_LIST5_PATH) {
            history.push(`${DASHBOARD_GUIDE_BOX_LIST5_PATH}?queryStr=gameCode=demo&backUrl=/dashboard/game/demo/overview/daily&pageName=总览-运营总况日报&path=/overview/daily&pageType=path`);
          }
        }
      });
    }
    return {
      mainTitle: formatMessage({id: 'dbh_dashboard_giudebox_title'}),
      mainDes: formatMessage({id: 'dbh_dashboard_giudebox_desc'}),
      blockTitle: formatMessage({id: 'dbh_dashboard_giudebox_block_title'}),
      blockList
    };
  }, [locale, guideSys, userInfo, location])

  return guideSys === GUIDE_SYS_DASHBOARD && userInfo && <UserGuideBox
    className={`dbd-guidebox ${locale === LANGUAGE_EN ? 'en' : 'cn'}`}
    data={GuideData}
    setShowGuide={setShowGuide}
  />;
}
